







































































import {Component} from '@/shared/component';
import {Pile} from '@/models';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';

import storePile from '@/stores/modules/pile';

import CrudFournisseurShow from '@/components/Crud/Fournisseur/Show.vue';
import CrudFournisseurEdit from '@/components/Crud/Fournisseur/Edit.vue';

@Component({
	components: {
		CrudFournisseurShow,
		CrudFournisseurEdit,
	}
})
export default class CrudPileShow extends AbstractShowVue<Pile> {
	public constructor() {
		super(storePile);
	}
}
